export const formatMonthName = (monthName: string) => {
  const monthNameWithoutLastChar = monthName.slice(0, monthName.length - 1)

  if (monthName[monthName.length - 1] === 'ь' || monthName[monthName.length - 1] === 'й') {
    return monthNameWithoutLastChar + 'я'
  } else {
    return monthName + 'а'
  }
}
